var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',{style:(`width:${_vm.readlWidth};height:${_vm.realHeight};`),attrs:{"src":`${_vm.realSrc}`,"fit":"cover","preview-src-list":_vm.realSrcList},scopedSlots:_vm._u([{key:"error",fn:function(){return [_c('div',{staticClass:"image-slot"},[_c('span',[_vm._v("暂无")])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }